import {
    type FC
} from "react";
import type IAreaChartProps from "./type";
import LineChartTrend from "../lineChart/components/trend";

const AreaChart: FC<IAreaChartProps> = ({
    stackBehaviour = "overlay",
    fill = "gradient",
    ...props
}) => {
    return <LineChartTrend
        {...props}
        stackBehaviour={stackBehaviour}
        isShowDots={false}
        isFilled={true}
        fill={fill}
    />;
};

export default AreaChart;
